import React from "react";
import { Button } from "react-bootstrap";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export function downloadExcel(list_combined) {
  
  const data_to_consider = list_combined[0];

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Period");

  // Extract period description
  sheet.addRow([data_to_consider[0]]);

  const listColumn = ["NozzleType", "GasType", "Tool", "Thickness", "MaterialName", "MaterialCutted"];
  let headers = [];
  data_to_consider[1].forEach((df, index) => {
    headers.push(...listColumn.slice(index, index + 1), "TimeDiff", ""); // Add empty column for spacing
  });

  // Leave one empty row
  sheet.addRow([]);

  // Add headers
  const headerRow = sheet.addRow(headers);

  // Apply styles to headers
  headerRow.eachCell((cell) => {
    if (cell.value !== "") {
      cell.font = { bold: true};
      cell.alignment = { horizontal: "center", vertical: "middle" };
  
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } }
      };
    }
  });

  // Fill data
  let startCol = 1;
  data_to_consider[1].forEach((df) => {
    const dataKey = Object.keys(df)[0];

    const sortedData = Object.values(df[dataKey])
      .map((item, i) => ({
        item,
        timeDiff: parseFloat(df["TimeDiff"][i].toFixed(2)),
      }))
      .sort((a, b) => b.timeDiff - a.timeDiff);

    // Add sorted data to the sheet
    sortedData.forEach((data, rowIndex) => {
      // Add each row to the corresponding column (with offset)
      const row = sheet.getRow(4 + rowIndex); // Start adding data from the 4th row
      row.getCell(startCol).value = data.item; // Column for the current property
      row.getCell(startCol + 1).value = data.timeDiff; // Column for TimeDiff
    });

    startCol += 3;
  });

  // Adjust column widths
  sheet.columns = headers.map(() => ({ width: 20 }));

  // Generate file and trigger download
  workbook.xlsx.writeBuffer().then((buffer) => {
    saveAs(new Blob([buffer]), "report_production.xlsx");
  });
}

const ExportExcel = ({ list_combined }) => (
  <div>
    <Button onClick={() => downloadExcel(list_combined)} size="lg" variant="success">
      Export Excel
    </Button>
  </div>
);

export default ExportExcel;
